<template>
    <div>
        <div v-if="!showNoResultAlert">
            <div class="fixed-header-top-div">
                <div class="fixed-header-container">
                    <table class="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th v-for="col in tableColumns" v-bind:key="col.key">
                                {{ $t(col.label) }}
                                <div scope="col" v-if="col.form.type == 'checkbox'">
                                    <b-form-checkbox
                                            @click.native.stop
                                            @change="toggleAll"
                                            inline
                                    />
                                </div>
                                <div scope="col" v-else>
                                    {{ $t(col.label) }}
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody v-if="newRows.length > 0">
                        <tr v-for="(row, index) in newRows" v-bind:key="index">
                            <td v-for="col in tableColumns" v-bind:key="col.key">
                                <div v-if="col.form.type == 'checkbox'">

                                </div>
                                <div v-else-if="col.form.type == 'modalEdit'">
                                    <b-btn v-if="isRowEditing(row)"
                                            size="sm"
                                            @click="showModalEditValue({action:'edit', scope:'add'}, row, col)">{{ $t("btn.basic.edit") }}
                                    </b-btn>
                                    <b-btn v-else 
                                            size="sm"
                                            @click="showModalEditValue({action:'view', scope:'add'}, row, col)">{{ $t("btn.basic.show") }}
                                    </b-btn>
                                </div>
                                <div v-else-if="col.form.type == 'actions'">
                                    <mmf-button type="cancel"
                                                v-bind:class="'btn btn-outline-secondary btn-sm mr-1'"
                                                v-on:click="cancelAddedRow(row)">
                                    </mmf-button>
                                    <mmf-button type="check"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                v-on:click="saveAddedRow(row)">
                                    </mmf-button>
                                </div>
                                <div v-else>
                                    <mmf-form-helper :metadata="col" :isEditing="isRowEditing(row)" :value="row[col.key]" @input="changeNewEntityAttribute(col, row, $event)" ></mmf-form-helper>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tbody>
                            <tr v-for="row in rows" v-bind:key="row.id">
                                <td v-for="col in tableColumns" v-bind:key="col.key">
                                    <div v-if="col.form.type == 'checkbox'">
                                        <b-form-checkbox @click.native.stop
                                                         :checked="isChecked(row)"
                                                         @change="MMFselectRow({item: row, module:entity})"
                                                         :disabled="isRowEditing(row)"
                                                          inline/>
                                    </div>
                                    <div v-else-if="col.form.type == 'modalEdit'">
                                        <b-btn v-if="isRowEditing(row)"
                                               size="sm"
                                               @click="showModalEditValue({action:'edit', scope:'edit'}, row, col)">{{ $t("btn.basic.edit") }}
                                        </b-btn>
                                        <b-btn v-else
                                               size="sm"
                                               @click="showModalEditValue({action:'view', scope:'edit'}, row, col)">{{ $t("btn.basic.show") }}
                                        </b-btn>
                                    </div>
                                    <div v-else-if="col.form.type == 'actions'">
                                        <div v-if="isRowEditing(row)">
                                            <mmf-button type="cancel"
                                                        v-bind:class="'btn btn-outline-secondary btn-sm mr-1'"
                                                        v-on:click="cancelRowEdit(row)">
                                            </mmf-button>
                                            <mmf-button type="check"
                                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                                        v-on:click="saveEditedRow(row)">
                                            </mmf-button>
                                        </div>
                                        <div class="btn-group" v-else>
                                            <mmf-button type="edit"
                                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                                        v-on:click="editRow(row)">
                                            </mmf-button>
                                            <mmf-button type="delete"
                                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                                        v-on:click="delRow(row)">
                                            </mmf-button>
                                            <mmf-button type="showEntity"
                                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                                        @click="showEntity(row)">
                                            </mmf-button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <mmf-form-helper :metadata="col" :isEditing="isRowEditing(row)" :value="row[col.key]" @input="changeEntityAttribute(col, row, $event)"></mmf-form-helper>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <mmf-pagination :entity="entity"
                            :totalRows="totalRows"
                            :perPage="rowsPerPage"
                            v-on:change:perpage="rowsPerPage = $event"
                            :currentPage="currentPage"
                            v-on:change:page="currentPage = $event">
            </mmf-pagination>
        </div>
        <form id="my_form"></form>
        <mmf-no-result-alert :isVisible="showNoResultAlert">
        </mmf-no-result-alert>
        <b-modal ref="modalViewer" centered :title="modelEditColumnLabel" size="lg" ok-only :ok-title="$t('lbl.basic.close')">
            <b-card>
                <b-row class="mb-2">
                    <p class="my-4">{{ modalEditValue }}</p>
                </b-row>
            </b-card>
        </b-modal>
        <b-modal ref="modalEditor" centered :title="modelEditColumnLabel" size="lg" :ok-title="$t('btn.basic.save')" :cancel-title="$t('lbl.basic.cancel')" @ok="saveModalEditValue">
            <div class="d-block text-center">
                <textarea v-model="modalEditValue" style="width: 100%" rows="15" />
            </div>
        </b-modal>
    </div>
</template>


<script>
import MmfButton from "@/components/MmfButton";
import MmfNoResultAlert from "@/components/MmfNoResultAlert";
import MmfPagination from "@/components/MmfPagination";
import MmfFormHelper from "@/components/MmfFormHelper";
import MmfLimitationAlert from "@/components/MmfLimitationAlert";

import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import model from '@/model/index' 

let checkboxField = {
    key: 'state',
    label: 'state',
    isControlField: true,
    form: {
        type: 'checkbox'
    }
};

let actionField = {
    key: 'actions',
    label: 'Actions',
    isActionField: true,
    form: {
        type: 'actions'
    }
};

export default {
    name: 'mmf-table',
    data() {
        return {
            modalEditValue: "",
            modelEditColumnLabel: "",
            modelEditColumnKey: "",
            modelEditMode: {},
            modalEditRow: null
        }
    },
    components: { MmfButton, MmfNoResultAlert, MmfPagination, MmfFormHelper, MmfLimitationAlert },
    props: {
        'actions': {
            main: String,
            default: Boolean,
            more: Array
        },
        'entity': String,
        'checkboxColumnDisabled': {
            type: Boolean,
            default: false
        },
        'inlineActionsDisabled': {
            type: Boolean,
            default: false
        },
    },
    computed: {
        tableColumns() {
            let gridFields = model[this.entity].gridFields();
            let entityData = [];
            if (!this.checkboxColumnDisabled) {
                entityData.push(checkboxField);
            }
            entityData = entityData.concat(gridFields);
            if (!this.inlineActionsDisabled) {
                entityData.push(actionField);
            }
            return entityData;
        },
        rows: {
            get () {
                return this.$store.state[this.entity].rows;
            }
        },
        newRows: {
            get () {
                return this.$store.state[this.entity].newRows;
            }
        },
        editingRows: {
            get () {
                return this.$store.state[this.entity].editingRows;
            }
        },
        checkedItems: {
            get () {
                return this.$store.state[this.entity].checkedItems;
            },
            set (value) {
                this.$store.commit(this.entity + '/setCheckedItems', value);
            }
        },
        currentPage: {
            get() {
                return this.$store.state[this.entity].currentPage;
            },
            set(value) {
                this.$store.commit(this.entity + '/setCurrentPage', value);
            }
        },
        rowsPerPage: {
            get() {
                return this.$store.state[this.entity].fixedFilter.numRegPag;
            },
            set(value) {
                this.$store.commit(this.entity + '/setRowsPerPage', value);
                this.$store.commit(this.entity + '/setCurrentPage', 1);
            }
        },
        totalRows() {
            return this.$store.state[this.entity].fixedFilter.totalReg;
        },
        newEntity() {
            return model[this.entity].newEntity();
        },
        showNoResultAlert() {
            return this.$store.state[this.entity].showNoResultAlert;
        },
        itemLimitationAlert: {
            get() {
                return this.$store.state[this.entity].itemLimitationAlert;
            },
            set(value) {
                this.$store.commit(this.entity + '/setItemLimitationAlert', value);
            }
        }
    },
    methods: {
        toggleAll(checked) {
            if(!checked){
                this.$store.commit(this.entity + "/setCheckedItems", [] );
                return;
            }

            var auxVector = []
            for (let i in this.$store.state[this.entity].rows)
                auxVector.push(this.$store.state[this.entity].rows[i].id)

            this.$store.commit(this.entity + "/setCheckedItems", auxVector);
        },
        showEntity(row) {
          this.$modal.entityModal(this.entity, row)
        },
        showModalEditValue(mode, row, col){
            this.modelEditMode = mode;
            this.modalEditValue = row[col.key];
            this.modelEditColumnLabel = col.label;
            this.modelEditColumnKey = col.key;
            this.modalEditRow = row;
            if (mode.action == 'edit') {
                this.$refs.modalEditor.show()
            }
            else {
                this.$refs.modalViewer.show()
            }
        },
        actionDisabled(type) {
            if (type == 'delete'){
                return (this.checkedItems.length) == 0;
            }
            else {
                return (this.checkedItems.length) != 1;
            }
        },
        addRow() {
            if (this.newRows.length == 0) {
                var newRow =  model[this.entity].newEntity();
                this.$store.commit(this.entity + "/addNewRow", newRow);
            }
        },
        saveAddedRow(row) {
            this.$store.commit(this.entity + "/setEntity", row);
            this.$validator.validateAll().then(isValid => {
                if( isValid ){
                    this.$store.dispatch('base/MMFSaveInline', this.entity);
                    this.$store.commit(this.entity + "/removeNewRow", row);
                }
            });
        },
        saveEditedRow(row) {
            this.$store.commit(this.entity + "/setEntity", row);
            this.$validator.validateAll().then(isValid => {
                if( isValid ){
                    this.$store.dispatch('base/MMFSaveInline', this.entity);
                    this.newRows.pop();
                }
            });
        },
        cancelAddedRow(row) {
            this.$store.commit(this.entity + "/removeNewRow", row);
        },
        cancelRowEdit(row) {
            this.$store.commit(this.entity + "/removeEditingRow", row);
        },
        editRow(row) {
            this.$store.commit(this.entity + "/addEditingRow", row);
        },
        delRow(row) {
            var modifiedRows = this.rows.filter(x => x.id !== row.id);
            this.$store.commit(this.entity + "/setRows", modifiedRows);
        },
        saveModalEditValue() {
            if (this.modelEditMode.scope == 'edit') {
                this.$store.commit(this.entity + "/setRow", {row: this.modalEditRow, key: this.modelEditColumnKey, newValue: this.modalEditValue});
            }
            else {
                this.$store.commit(this.entity + "/setNewRow", {row: this.modalEditRow, key: this.modelEditColumnKey, newValue: this.modalEditValue});
            }
        },
        changeNewEntityAttribute(col, row, $event) {
            this.$store.commit(this.entity + "/setNewRow", {row: row, key: col.key, newValue: $event});
        },
        changeEditEntityAttribute(col, row, $event) {
            this.$store.commit(this.entity + "/setRow", {row: row, key: col.key, newValue: $event});
        },
        isRowEditing(row) {
            if (row.id == null) {
                return true;
            }
            let result = this.editingRows.some(r => r.id == row.id);
            return result;
        },
        isChecked(row) {
            let result = this.checkedItems.some(rowid => rowid == row.id);
            return result;
        },
        ...mapActions("base", ["MMFselectRow", "MMFSaveInline", "MMFEdit", "MMFDelete", "MMFExport"])
        }
}
</script>
